module.exports = __webpack_public_path__ + "img/Progress-Report-Inspect-Portrait.ad78c961.png";